import React from 'react';


interface Function {
  id: string;
  name: string;
  description?: string;
}

interface Group {
  id: string;
  name: string;
  description?: string;
}
interface UserRoleFunctionSelectorProps {
  functions: Function[];
  groups: Group[];
  selectedGroupId: string;
  selectedFunctionIds: string[];
  onGroupChange: (groupId: string) => void;
  onFunctionIdsChange: (functionIds: string[]) => void;
  disabled?: boolean;
}


const UserRoleFunctionSelector = ({
  functions,
  groups,
  selectedGroupId,
  selectedFunctionIds,
  onGroupChange,
  onFunctionIdsChange
}: UserRoleFunctionSelectorProps) => {
  const handleFunctionToggle = (functionId: string, checked: boolean) => {
    if (checked) {
      onFunctionIdsChange([...selectedFunctionIds, functionId]);
    } else {
      onFunctionIdsChange(selectedFunctionIds.filter(id => id !== functionId));
    }
  };

  const selectedGroup = groups.find(g => g.id === selectedGroupId);

  return (
    <div className=" " >
      <div className="">
        {/* Group Selection */}
        <div className="mb-3">
          <label className="form-label fw-semibold">User Group <span className="text-danger">*</span></label>
          <select
            value={selectedGroupId}
            onChange={e => onGroupChange(e.target.value)}
            className="form-control rounded"
                                    style={{ minHeight: 48 }}

          >
            <option value="" disabled>Select a group</option>
            {groups.map((group) => (
              <option key={group.id} value={group.id}>
                {group.name} {group.description ? `- ${group.description}` : ''}
              </option>
            ))}
          </select>
          {selectedGroup?.description && (
            <div className="form-text text-muted">{selectedGroup.description}</div>
          )}
        </div>

        {/* Function Selection */}
        <div>
          <label className="form-label fw-semibold mb-2" >Function Assignments <span className="">*</span></label>
          {functions.length === 0 ? (
            <div className="border rounded bg-light p-3 text-center text-secondary pt-2">
              <p className="small mb-0">No functions available. Create functions first to assign users.</p>
            </div>
          ) : (
            <div className="row g-2 ">
              {functions.map((func) => (
                <div key={func.id} className="col-12 col-md-6 ">
                  <div className="form-check mb-2   h-100">
                    <input
                      type="checkbox"
                      id={`function-${func.id}`}
                      checked={selectedFunctionIds.includes(func.id)}
                      onChange={e => handleFunctionToggle(func.id, e.target.checked)}
                      className="form-check-input"
                    />
                    <label htmlFor={`function-${func.id}`} className="form-check-label ms-2">
                      <span className="fw-medium">{func.name}</span>
                      {func.description && (
                        <span className="d-block small text-muted">{func.description}</span>
                      )}
                    </label>
                  </div>
                </div>
              ))}
              {selectedFunctionIds.length === 0 && (
                <div className="col-12">
                  <p className="small text-secondary mt-2">Select at least one function to assign this user.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserRoleFunctionSelector;
